import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import { investorApi } from "../../api/api";
import { logoutUser } from "./userReducer";

const initialState = {
  list: [],
};

export const getAllNotifications = createAsyncThunk(
    "notification/getAll" ,
    async(userId)=>{
        const response = await investorApi.getNotifications(userId);
        return response.data || [];
    }
);

export const deleteNotification = createAsyncThunk(
    "notification/delete",
    async(id)=>{
        await investorApi.deleteNotificationById(id);
        return id;
    }
);

export const deleteAllTeamNotification = createAsyncThunk(
    "/notifications/deleteAll" ,
    async (userId) => {
        const res =await investorApi.deleteAllNotifications(userId);
        return [];
    }
);

export const markAllNotiAsRead = createAsyncThunk(
    "/notifications/markAll",
    async (userId) =>{
        await investorApi.markAllAsRead(userId);
        return;
    }
);
export const markAsRead = createAsyncThunk(
    "notification/markAsRead",
    async(id)=>{
     await investorApi.markAsRead(id);
        return id;
    }
);


const NotificationSlice = createSlice({
    name:"notification",
    initialState: {
        list:[],
    },
    reducers: {},
    extraReducers: (builder) => {
       builder
         .addCase(getAllNotifications.fulfilled, (state, action) => {
           state.list = action.payload;
         })
         .addCase(deleteNotification.fulfilled, (state, action) => {
           state.list = state.list.filter((n) => n.id !== action.payload);
         })
         .addCase(deleteAllTeamNotification.fulfilled, (state) => {
           state.list = [];
         })
         .addCase(markAllNotiAsRead.fulfilled, (state) => {
           state.list = state.list.map((n) => ({
             ...n,
             status: "Read",
           }));
         })
         .addCase(markAsRead.fulfilled, (state, action) => {
     const id = action.payload;
     const notification = state.list.find((n) => n.Id === id);
     if (notification) {
       notification.Status = "Read";
     }

   })
     .addCase(logoutUser, () => initialState);
         
     },
   
})
export default NotificationSlice.reducer;